import { LANGUAGES } from "@logora/debate.util.lang_emojis";
import SaveIcon from "@mui/icons-material/Save";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import {
	useDataProvider,
	useGetIdentity,
	useNotify,
	useTranslate,
} from "react-admin";

const useStyles = makeStyles({
	form: {
		width: "300px",
		display: "flex",
		"flex-direction": "column",
		justifyContent: "center",
		alignItems: "start",
	},
	submit: { "margin-top": "1em", "margin-bottom": "0.5em" },
});

const UpdateLanguageForm = () => {
	const translate = useTranslate();
	const dataProvider = useDataProvider();
	const notify = useNotify();
	const classes = useStyles();
	const { data: identity, refetch } = useGetIdentity();

	const [language, setLanguage] = useState(identity.language);

	const handleUpdateLanguage = (event) => {
		event.preventDefault();
		dataProvider
			.updateMe({ language: language })
			.then((response) => {
				localStorage.setItem(
					"currentUser",
					JSON.stringify(response.data.data.resource),
				);
				notify(translate("resources.update_language.notifications.success"), {
					type: "info",
					undoable: true,
				});
				refetch();
			})
			.catch((error) => {
				notify(translate("resources.update_language.notifications.error"), {
					type: "warning",
					undoable: true,
				});
			});
	};

	return (
		<form className={classes.form} onSubmit={handleUpdateLanguage}>
			<FormControl variant="outlined" className={classes.selectInput}>
				<Select
					id="language_select"
					value={language}
					onChange={(e) => setLanguage(e.target.value)}
				>
					{Object.keys(identity.settings.translation.translationMethods).map(
						(lang) => (
							<MenuItem key={lang} value={lang}>
								{LANGUAGES.map(
									(e) => e.name === lang && lang.toUpperCase() + e.icon,
								)}
							</MenuItem>
						),
					)}
				</Select>
			</FormControl>
			<Button
				className={classes.submit}
				type="submit"
				color="primary"
				variant="contained"
				startIcon={<SaveIcon />}
				fullWidth={false}
			>
				{translate("resources.update_language.fields.save")}
			</Button>
		</form>
	);
};

export default UpdateLanguageForm;
